import { useTranslation } from 'react-i18next'
import { AppleChar } from '../AppleChar'

export function MaintenanceScreen() {
  const { t } = useTranslation()

  return (
    <div className="fullscreen-state" role="status" aria-live="polite">
      <AppleChar size={80} mood="sleepy" />
      <p className="fullscreen-state__title">{t('screens.maintenance.title')}</p>
      <p className="fullscreen-state__hint">{t('screens.maintenance.hint')}</p>
    </div>
  )
}
